import { call } from 'redux-saga/effects'
import { APIS } from '../../_config'
import { CallApi } from '../api/callApi'
import { ErrorResponse, SuccessResponse } from '../api/apiTypes'
import { trackError } from '../../utils/analytics/rumTracking'

export function* getBlockingFactor<P, R>(action: { type: string; payload: any; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const resp = yield call(CallApi.POST, APIS.BLOCKING_FACTOR.GET_BLOCKING_FACTOR_DATA, action.payload)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // action?.onError({
        //     message: e.message,
        //     status_code: 400,
        //     success: false,
        // })/
        // ✅ CHANGED: Added optional chaining to e.message
        action?.onError({
            message: e?.message || 'Failed to fetch blocking factor data',
            status_code: 400,
            success: false,
        })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'getBlockingFactor', action: action?.type })
    }
}
